import filter from 'lodash/filter'
import includes from 'lodash/includes'
import React from 'react'
import { ToggleButton } from 'react-bootstrap'

import { HorizontalStack } from '@ztechapps/webui.util'
import { useTrackEvent } from '@ztechapps/webui.telemetry'

import type { OnChangeFilter } from '../../../../config/types'
import { useContext } from '../Context'
import { FilterGroup } from './FilterGroup'

const ShapeItem = ({
  label,
  value,
  shapesFilter,
  onChangeFilter,
}: {
  label: string
  value: string
  shapesFilter: string[]
  onChangeFilter: OnChangeFilter
}) => {
  const trackEvent = useTrackEvent()
  const { onBoarding } = useContext()

  const onChange = (e) => {
    const isChecked = e?.target?.checked
    let newShapesFilter = filter(shapesFilter, (e) => e !== value)
    if (isChecked) {
      newShapesFilter = [value]
      trackEvent('Shape filter', { shape_label: label, shape_value: value })
    }
    onChangeFilter({ shapesFilter: newShapesFilter })
    onBoarding?.goNext()
  }

  const checked = includes(shapesFilter, value)

  return (
    <ToggleButton
      id={value}
      type="checkbox"
      variant="outline-primary"
      name="shapes"
      value={value}
      checked={checked}
      onChange={onChange}
    >
      <img src={`/images/die-shapes/${value}.png`} className="img-fluid" width={20} height={20} alt="Filter shapes" />{' '}
      {label}
    </ToggleButton>
  )
}

/**
 * We use the custom radio buttons here, we cannot re-use from the lib because it uses "name" props and
 * conflicts with controlled component
 * @constructor
 */
export const Shape = () => {
  const { onChangeFilter, shapesFilter, metadataSchema } = useContext()

  const [shapes, setShapes] = React.useState([])
  React.useEffect(() => {
    if (metadataSchema) {
      setShapes([...(metadataSchema?.shape?.inputProps?.options ?? {})])
    }
  }, [metadataSchema])

  return (
    <FilterGroup filterName="shapes" title="Shapes">
      <div data-joyridestep="filter_shape">
        <HorizontalStack gap={2} className="flex-wrap">
          {shapes.map((shape) => {
            return <ShapeItem key={shape?.value} {...{ ...shape, onChangeFilter, shapesFilter }} />
          })}
        </HorizontalStack>
      </div>
    </FilterGroup>
  )
}
